import { createContext, useContext, type ReactNode } from 'react';
import { useTheme as useWebTheme, type ThemeMode } from '../context/ThemeContext';

interface AppThemeContextType {
  theme: 'light' | 'dark';
  isDark: boolean;
  setTheme: (theme: ThemeMode) => void;
}

const AppThemeContext = createContext<AppThemeContextType | undefined>(undefined);

// 由命理乾坤WEB版的 ThemeProvider 驱动（支持跟随系统），
// 这里只做 API 适配供二期同步页面使用
export function ThemeProvider({ children }: { children: ReactNode }) {
  const { effectiveTheme, setTheme } = useWebTheme();
  const value: AppThemeContextType = {
    theme: effectiveTheme,
    isDark: effectiveTheme === 'dark',
    setTheme,
  };
  return (
    <AppThemeContext.Provider value={value}>
      {children}
    </AppThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(AppThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
